// extracted by mini-css-extract-plugin
export var aircallIframe = "_jr-3";
export var fabContainer = "_jr-5";
export var fabRinging = "_jr-6";
export var loadingOverlay = "_jr-4";
export var pulse = "_jr-7";
export var widgetContent = "_jr-2";
export var widgetPanel = "_jr-0";
export var widgetPanelExpanded = "_jr-1";